import { Content, asText } from '@prismicio/client';

import { Box, Badge, Wrapper, Typography } from '@preventx/oxygen';

// Types
import { ActionLink } from '@/types/components/actions';

// Services
import { badgeColour } from '@/services/utils/colour';
import { retrieveIcon } from '@/services/utils/icons';

// Components
import { ActionLinks } from '@/components/Actions/ActionLinks';
import { RichTextHero } from '@/components/RichText/RichTextHero';

export type DefaultHeroProps = {
  id: string;
  slice: Content.HeroSliceDefault;
};

export const DefaultHero = ({ id, slice }: DefaultHeroProps) => {
  const { primary } = slice;
  const { badges, lede, title, caption, actions, background_type } = primary;

  const mappedActions = actions.map((item): ActionLink => ({
    action: item.action,
    addOutline: item.add_ghost_effect,
    icon: item?.icon !== 'None' ? retrieveIcon(item.icon) : undefined,
  }));

  return (
    <Wrapper size="lg">
      <Box component="div" className="hero__content" addFlow>
        <Box component="div" className="intro" addFlow>
          {badges.map(({ label, variant }, index) => {
            const key = `home-hero-${id}-${index + 1}`;
            const response = badgeColour(variant);

            return (
              <Badge
                id={key}
                key={key}
                className="w-max-unset"
                colour={response?.colour}
                variant={response?.variant}
              >
                {asText(label)}
              </Badge>
            );
          })}

          <RichTextHero content={title} />

          <Typography component="p" className="lede">
            {asText(lede)}
          </Typography>

          <RichTextHero content={caption} />
        </Box>

        {actions && (
          <Box component="div" className="hero__actions" addCluster>
            <ActionLinks idPrefix="hero-actions" actions={mappedActions} />
          </Box>
        )}
      </Box>

      {background_type === 'Gradient Wrapper' && (
        <Box component="div" className="bg-grad-wrapper">
          <Box component="div" className="bg-grad">
            <div className="bg-grad-img"></div>
          </Box>
        </Box>
      )}
    </Wrapper>
  );
};
